import React, { Component } from "react";
import { Helmet } from "react-helmet";
import i18n from "i18next";
import writeCookie from "../function/writeCookie";
import getCookie from "../function/getCookie";
import urlReplace from "../function/replaceUrl";
import { connect } from "react-redux";
import {
  product,
  login,
  countryList,
  browsingHistory,
  cart,
  loginPopup,
  mobileMenu,
  loading,
  myFav
} from "../models";
import WishListBox from "../components/WishListBox";
import { Translation } from "react-i18next";

class WishList extends Component {
  state = {
    lang: "zhTW"
  };
  async componentDidMount() {
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    const isCheckoutPage = false;
    const isProductDetailsPage = true;
    const {
      fetchCountryList,
      fetchUser,
      showLoginPopup,
      showMobileMenu,
      fetchMenuCountryList,
      fetchCart,
      fetchMyFavList,
      updateMyFav
    } = this.props;

    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }

    window.addEventListener("message", function (event) {
      if (event.data === "emphasisSuccess") {
        showLoginPopup(false); //登入成功後便關閉Popup畫面
        showMobileMenu(false); //登入成功後便關閉手機板Menu畫面
        fetchUser(isCheckoutPage, isProductDetailsPage);
      }
      return;
    });

    fetchCountryList();
    fetchMenuCountryList();
    fetchUser(isCheckoutPage, isProductDetailsPage);
    fetchCart();
    fetchMyFavList();
    window.addEventListener("message", e => {
      if (e.data === "HEADER_UPDATE_WISHLIST") {
        fetchMyFavList();
      }
      if (e.data === "HEADER_UPDATE_MINI_CART") {
        fetchCart();
      }
    });
  }
  async handleClickLang(event) {
    const { fetchCountryList, fetchMenuCountryList } = this.props;

    if (event.target.value === "en") {
      i18n.changeLanguage("en");
      writeCookie("eshop-hk-language", "en");
      this.setState({
        lang: "en"
      });
      /*塞en回url字串*/
      urlReplace(window.location.pathname, "tc", "en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      writeCookie("eshop-hk-language", "zh_HK"); //香港網站
      this.setState({
        lang: "zhTW"
      });
      /*塞tc回url字串*/
      urlReplace(window.location.pathname, "en", "tc");
    }

    fetchCountryList(); // 切換語系，取得英文國家列表
    fetchMenuCountryList();
  }
  render() {
    const { lang } = this.state;
    return (
      <div>
        <Helmet>
          {/* SEO */}
          {lang === "en" ? (
            <title>EMPHASIS&nbsp;&nbsp;|&nbsp;&nbsp;WISH LIST</title>
          ) : (
            <title>EMPHASIS&nbsp;&nbsp;|&nbsp;&nbsp;願望清單</title>
          )}
           <link rel="canonical" href={window.location.href} />
        </Helmet>
        <div id="header"></div>
        <div className="pageContent_wrap">
          <div className="pdtListingWBanners_wrap">
            <div>
              <div className="content-wrapper-wider">
                <span className="h2">
                  <Translation>
                    {t => <>{t("wishListBag.title")}</>}
                  </Translation>
                </span>
                <p></p>
              </div>
              <div className="pdtListing_wrap">
                <div className="content-wrapper-wider">
                  <WishListBox />
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer id="footer"></footer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    product: state.product.productBookingUnit,
    isLoading: state.loading.isLoading
  };
};

const mapDispatchToProps = () => {
  return {
    fetchProduct: cbu => product.actions.fetchProduct(cbu),
    fetchCart: () => cart.actions.fetchCart(),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchMenuCountryList: () => countryList.actions.fetchMenuCountryList(),
    fetchUser: (isCheckoutPage, isProductDetailsPage) =>
      login.actions.fetchUser(isCheckoutPage, isProductDetailsPage),
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode),
    fetchBrowsingHistory: () => browsingHistory.actions.fetchBrowsingHistory(),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    showMobileMenu: bool => mobileMenu.actions.showMobileMenu(bool),
    startLoading: bool => loading.actions.startLoading(bool),
    fetchMyFavList: () => myFav.actions.fetchMyFavList(),
    updateMyFav: (data, bool) => myFav.actions.updateMyFav(data, bool)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WishList);
